import React, { useEffect, useState } from "react";
import "./Home.css";
import { TypeAnimation } from "react-type-animation";

import githubIcon from "../../assets/github.png";
import leetcodeIcon from "../../assets/leetcode.png";
import linkedinIcon from "../../assets/linkedIn.webp";
import rynabout from "../../assets/rynabout.png";
import linkedinTag from "../../assets/linkedin-tag.png";
import githubTag from "../../assets/github-tag.png";
import leetcodeTag from "../../assets/leetcode-tag.png";

const platformData = [
  {
    name: "rryn on:",
    icon: leetcodeIcon,
    className: "leetcode",
  },
  {
    name: "RynThakur on:",
    icon: githubIcon,
    className: "github",
  },
  {
    name: "Aryan Thakur on:",
    icon: linkedinIcon,
    className: "linkedin",
  },
];

const Home = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % platformData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const { name, icon, className } = platformData[current];

  return (
    <>
      <section id="home">
        <div className="section__pic-container">
          <img src={rynabout} alt="Ryn" />
        </div>

        <div className="section__text">
          <p className="section__text__p1">Hello, I'm</p>

          <h1 className="title">
            <span className={`animated-name ${className}`}>
              <TypeAnimation
                key={name}
                sequence={[name, 2000]}
                wrapper="span"
                speed={50}
                repeat={1}
              />
              <img src={icon} alt="platform" className="platform-icon" />
            </span>
          </h1>

          <p className="section__text__p2">Final Year CS Undergrad</p>

          <div className="btn-container">
            <button
              className="btn btn-color-2"
              onClick={() => window.open("/resume.pdf")}
            >
              Download CV
            </button>
            <button
              className="btn btn-color-1"
              onClick={() => (window.location.href = "#contact")}
            >
              Contact Info
            </button>
          </div>

          <div id="socials-container">
            <div className="social-icon-wrapper">
              <img
                src={linkedinIcon}
                alt="LinkedIn"
                className="icon"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/aryan-thakur-2b1a5b242/",
                    "_blank"
                  )
                }
              />
              <img
                src={linkedinTag}
                alt="LinkedIn Tag"
                className="social-tooltip"
              />
            </div>

            <div className="social-icon-wrapper">
              <img
                src={leetcodeIcon}
                alt="LeetCode"
                className="icon"
                onClick={() =>
                  window.open("https://leetcode.com/u/rryn/", "_blank")
                }
              />
              <img
                src={leetcodeTag}
                alt="LeetCode Tag"
                className="social-tooltip"
              />
            </div>

            <div className="social-icon-wrapper">
              <img
                src={githubIcon}
                alt="GitHub"
                className="icon"
                onClick={() =>
                  window.open("https://github.com/RynThakur", "_blank")
                }
              />
              <img
                src={githubTag}
                alt="GitHub Tag"
                className="social-tooltip"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
